import { RootState } from '../../../app';

export const selectFiles = ({ fileUploading }: RootState) =>
  fileUploading.files;

export const selectFile =
  (id: string) =>
  ({ fileUploading }: RootState) =>
    fileUploading.files.find((f) => f.id === id);
